// Card — wrapper con header (eyebrow + title + action) y footer opcionales.

export default function Card({
  title,
  eyebrow,
  action,
  children,
  footer,
  className = '',
  bodyClassName = 'p-5',
}) {
  const hasHeader = title || eyebrow || action
  return (
    <div className={`ui-card ${className}`}>
      {hasHeader && (
        <div className="flex items-center justify-between px-5 py-4 border-b border-[var(--line)]">
          <div>
            {eyebrow && <div className="eyebrow mb-1">{eyebrow}</div>}
            {title && <div className="font-medium text-[14px]">{title}</div>}
          </div>
          {action}
        </div>
      )}
      <div className={bodyClassName}>{children}</div>
      {footer && (
        <div className="px-5 py-3 border-t border-[var(--line)] text-[12px] text-[var(--ink-3)]">
          {footer}
        </div>
      )}
    </div>
  )
}
